import * as React from "react"
import { SVGProps } from "react"

const ShoppingBag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 1.25A2.5 2.5 0 0 0 5 3.75H3.125c-.69 0-1.25.56-1.25 1.25v6.25a2.5 2.5 0 0 0 2.5 2.5h6.25a2.5 2.5 0 0 0 2.5-2.5V5c0-.69-.56-1.25-1.25-1.25H10a2.5 2.5 0 0 0-2.5-2.5Zm1.25 2.5a1.25 1.25 0 1 0-2.5 0h2.5Zm-5.625 7.5V5h8.75v6.25c0 .69-.56 1.25-1.25 1.25h-6.25c-.69 0-1.25-.56-1.25-1.25Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.817 7.058a.625.625 0 0 1 0 .884l-2.5 2.5a.625.625 0 0 1-.884 0l-1.25-1.25a.625.625 0 1 1 .884-.884l.808.808 2.058-2.058a.625.625 0 0 1 .884 0Z"
      fill="#fff"
    />
  </svg>
)

export default ShoppingBag
